import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapGetters } from 'vuex';
export default {
  name: 'Sidebar',
  setup: function setup() {
    var slideIn = ref(false);
    return {
      slideIn: slideIn
    };
  },
  data: function data() {
    return {
      tabs: {
        first: [{
          icon: 'user-icon',
          text: 'My Details',
          path: '/my-details'
        }, {
          icon: 'cv-icon',
          text: 'CV Profile',
          path: '/profile/cv'
        }, {
          icon: 'academic-cap',
          text: 'University Management',
          path: '/university-management'
        }, {
          icon: 'thumbs-up-icon',
          text: 'Preferences',
          path: '/general-preferences'
        }, {
          icon: 'setting-icon',
          text: 'Settings',
          path: '/settings'
        }, {
          icon: 'shield-check-outline',
          text: 'Account Verification',
          path: '/account-verification'
        }],
        second: [{
          icon: 'job-icon',
          text: 'Applied Jobs',
          path: '/jobs/applications'
        }, {
          icon: 'chat-bubble-left-right',
          text: 'Interviews',
          path: '/interviews'
        }, {
          icon: 'save-icon',
          text: 'Saved',
          path: '/saved-jobs'
        }, {
          icon: 'video-camera-outline',
          text: 'Mock Interviews',
          path: '/mock-interviews'
        }, {
          icon: 'cloud-arrow-up-outline',
          text: 'Upload CV',
          path: '/profile/cv/upload'
        }, {
          icon: 'download-icon',
          text: 'Export CV',
          path: '/profile/cv/template'
        }, {
          icon: 'question-icon',
          text: 'FAQs',
          path: '/faqs'
        }],
        last: [{
          icon: 'logout-icon',
          text: 'Logout',
          path: null
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    theme: 'getTheme'
  })), {}, {
    stellenboschApiEnabled: function stellenboschApiEnabled() {
      return process.env.STELLENBOSCH_UNIVERSITY_API_ENABLED === 'true';
    },
    userHasVerifiedStellenboschUniversity: function userHasVerifiedStellenboschUniversity() {
      var _this$$auth$user$univ;

      return (_this$$auth$user$univ = this.$auth.user.universities) === null || _this$$auth$user$univ === void 0 ? void 0 : _this$$auth$user$univ.some(function (university) {
        return university.code === 'sun' && Boolean(university.account.verified_at);
      });
    },
    profileCompletionPercentage: function profileCompletionPercentage() {
      var _this$$auth$user$prof;

      return ((_this$$auth$user$prof = this.$auth.user.profile_completion_status) === null || _this$$auth$user$prof === void 0 ? void 0 : _this$$auth$user$prof.percentage) || 0;
    },
    showEventsLink: function showEventsLink() {
      return this.$store.getters['workshops/getShowWorkshopsLink'];
    },
    applicantEmployabilityAward: function applicantEmployabilityAward() {
      if (this.$auth.user.employability_award === null) {
        return false;
      }

      return this.$auth.user.employability_award.charAt(0).toUpperCase() + this.$auth.user.employability_award.slice(1);
    }
  }),
  created: function created() {
    this.slide();
    this.updateVerificationTab();

    if (!this.showEventsLink) {
      var arr = this.tabs.second.splice(2, 1);
    }
  },
  watch: {
    slideIn: function slideIn(newValue) {
      var _this = this;

      if (!newValue) {
        setTimeout(function () {
          _this.$emit('close');
        }, 300);
      }
    }
  },
  methods: {
    slide: function slide() {
      var _this2 = this;

      setTimeout(function () {
        _this2.slideIn = !_this2.slideIn;
      }, 200);
    },
    goToTemplate: function goToTemplate() {
      this.$router.push(this.localePath({
        name: 'profile-cv-template'
      }));
    },
    completeProfile: function completeProfile() {
      this.slide();
      this.$router.push(this.localePath({
        name: 'profile-progress'
      }));
    },
    redirectToOauth: function redirectToOauth() {
      location.href = "".concat(this.$axios.defaults.baseURL, "/oauth/stellenbosch?path=").concat(this.$route.path);
    },

    /**
     * Disable the account verification tab and display a check
     * icon to it if the user has received manual verification.
     */
    updateVerificationTab: function updateVerificationTab() {
      if (!this.$auth.user.is_manually_verified) return;
      var index = this.tabs.first.findIndex(function (tab) {
        return tab.path === '/account-verification';
      });
      this.tabs.first[index] = {
        icon: 'shield-check-outline',
        text: 'Account Verified',
        path: '/account-verification',
        disabled: true,
        trailingIcon: {
          name: 'check-circle-solid',
          class: 'text-success'
        }
      };
    }
  }
};